module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absence-reasons__absence"
  }, [_c('div', [_c('div', {
    staticClass: "absence-reasons__absence__title"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.reason.title))])]), _vm._v(" "), _c('p', [(_vm.isOngoing) ? _c('span', {
    staticClass: "badge badge--orange badge--small badge--clickable",
    on: {
      "click": _vm.setTheEditAbsenceReason
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
    staticClass: "badge badge--small"
  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? [_vm._v("\n        " + _vm._s(_vm._f("date")(_vm.getSerialListItem.from_date)) + "\n        - " + _vm._s(_vm._f("date")(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm._f("showTime")(_vm.reason.start)) + " - " + _vm._s(_vm._f("showTime")(_vm.reason.end)) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm._f("showDate")(_vm.reason.start)) + " -\n        "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(_vm.reason.end)))])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "absence-reasons__absence__right"
  }, [_c('div', {
    staticClass: "absence-reasons__absence__right__edits"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'left'
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
    }],
    staticClass: "icon-bin icon__bg-circle icon__bg-circle--danger deleteAbsence",
    attrs: {
      "content": _vm.$t('vue2.common.delete')
    },
    on: {
      "click": function($event) {
        return _vm.setReadyToDelete(_vm.reason)
      }
    }
  }), _vm._v(" "), (_vm.getSerialListItem) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'left'
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
    }],
    staticClass: "icon-wrench icon__bg-circle",
    attrs: {
      "content": _vm.$t('vue2.common.edit')
    },
    on: {
      "click": function($event) {
        return _vm.setTheEditAbsenceReason(_vm.reason)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'left'
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
    }],
    staticClass: "icon-clock icon__bg-circle",
    attrs: {
      "content": _vm.$t('vue2.common.log')
    },
    on: {
      "click": function($event) {
        return _vm.showLog(_vm.reason)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38bc317e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsUserAbsenceReason.vue
// module id = 1534
// module chunks = 1